import {createStructuredSelector} from "reselect"
import {selectManagerOpenUrlFeatureEnabled} from "manager/selectors/manager_selectors"
import {connect} from "react-redux"
import {PRIVACY_POLICY_URL, QUALIA_PRIVACY_POLICY_URL, QUALIA_TERMS_URL} from "common/constants"
import React from "react"
import {goToLink} from "common/util/helper"

const OpenLink = connect(
  createStructuredSelector({openUrlFeatureEnabled: selectManagerOpenUrlFeatureEnabled})
)(
  ({ openUrlFeatureEnabled, url, children }) => {
    return (
      <a onClick={() => goToLink(openUrlFeatureEnabled, url)}>{children}</a>
    )
  }
)

export default function AuthorizeQualiaLegalese() {
  return (
    <span>
      <span>  I authorize realtor.com® and Qualia to exchange information about the status of the order as necessary.</span>
      <span>  By continuing, I agree to realtor.com's <OpenLink url={PRIVACY_POLICY_URL}>Privacy Policy</OpenLink> and <OpenLink url={`${window.location.origin}/settings/terms?standalone=true`}>Terms and Conditions</OpenLink> as well as Qualia’s <OpenLink url={QUALIA_PRIVACY_POLICY_URL}>Privacy Policy</OpenLink> and <OpenLink url={QUALIA_TERMS_URL}> Terms of Use.</OpenLink></span>
    </span>
  )
}

